import PNLReportRepository from "@adapters/repositories/Reports/PNLReport";
import PNLTransactionReportRepository from "@adapters/repositories/Reports/PNLTransactionReport";
import { downloadReportsRepo } from "../../../../components/Reports/understandingCommonDI/downloadReportsDI";
import { accountDetails, qouteStream } from "@di";
import DashboardRepository from "@adapters/repositories/Reports/common/dashboardRepo";
export default (http, infrastructure) => {
    return {
        pnlMainScreenRepo: new PNLReportRepository(http, accountDetails),
        pnlTransactionRepo: new PNLTransactionReportRepository(http, accountDetails),
        downloadRepo: downloadReportsRepo,
        quoteStream: qouteStream,
        dashboardRepo: new DashboardRepository(http, accountDetails),
    };
};
